import React from "react"
import makeStyles from "@material-ui/core/styles/makeStyles"
import Box from "@material-ui/core/Box"
import List from "@material-ui/core/List"
import ListItem from "@material-ui/core/ListItem"
import Typography from "@material-ui/core/Typography"
import ScrollButton from "../../bits/ScrollButton"

const useStyles = makeStyles(theme => ({
  Section: {
    background: theme.palette.secondary.main,
    padding: theme.spacing(0, 1, 15, 1),
  },
  Container: {
    maxWidth: 1200,
    margin: "auto",
    background: "transparent",
  },
  headline: {
    display: "grid",
    margin: "auto",
    justifyContent: "center",
  },
  h2: {
    fontSize: theme.typography.fontSize + 23,
    marginBottom: theme.spacing(2),

    [theme.breakpoints.down("md")]: {
      fontSize: theme.typography.fontSize + 17,
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(0),
      fontSize: theme.typography.fontSize + 9,
    },
    [theme.breakpoints.down("xs")]: {
      textAlign: "center",
    },
  },
  Description: {
    fontFamily: "RageItalic",
    fontSize: theme.typography.fontSize + 32,
    fontWeight: 900,
    textAlign: "center",
    [theme.breakpoints.down("xs")]: {
      textAlign: "center",
    },
  },
  details: {
    position: "relative",
    maxWidth: 1200,
    width: "100%",
    margin: "4em auto",
    boxSizing: "border-box",
    background: "transparent",
    "&:after": {
      position: "absolute",
      width: "100%",
      height: theme.spacing(5),
      content: `''`,
      left: 0,
      right: 0,
      bottom: -10,
      background: theme.palette.secondary.main,
    },
  },
  List: {
    paddingBottom: theme.spacing(4),
    background: "inherit",
    display: "block",
    width: "100%",
    width: "fill-available",
    height: "100%",
    boxSizing: "border-box",
    whiteSpace: "nowrap",
    overflowX: "auto",
    "-webkit-overflow-scrolling": "touch",
  },
  ListItem: {
    display: "inline-block",
    maxHeight: theme.spacing(56),
    width: theme.spacing(39),
    height: "100%",
    padding: 0,
    margin: theme.spacing(1),
    boxShadow: theme.shadows[8],
    background: theme.palette.background.paper,
    whiteSpace: "initial",
  },
  ListItemText: {
    textAlign: "center",
    padding: theme.spacing(2, 2),
    boxSizing: "border-box",
    "& h3": {
      fontSize: theme.typography.fontSize + 7,
      padding: theme.spacing(1.5),
      width: "max-content",
      margin: "auto",
    },
    "&  p:first-of-type": {
      fontWeight: "500",
    },
  },
  Btn: {
    position: "absolute",
    top: "45%",
    zIndex: 2,
    [theme.breakpoints.down("xs")]: {
      display: "none",
      visibility: "hidden",
    },
  },
  BtnLeft: {
    left: 0,
  },
  BtnRight: {
    right: 0,
  },
  imageBox: {
    background: "#ccc",
    width: "100%",
    minHeight: theme.spacing(19.4),
    maxHeight: theme.spacing(19.4),
    clipPath: `polygon(0 0,100% 0,100% 92%, 0% 100%)`,
    overflow: "hidden",
  },
  img: {
    width: "100%",
    height: "100%",
  },
  imageCircle: {
    position: "relative",
    width: theme.spacing(20),
    height: theme.spacing(20),
    marginBottom: theme.spacing(2),
    padding: "auto",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "100px",
    backgroundImage: `url(
      "data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='100' ry='100' stroke='black' stroke-width='2' stroke-dasharray='50%25%2c 59%25' stroke-dashoffset='86' stroke-linecap='butt'/%3e%3c/svg%3e"
      )`,

    "&:before": {
      position: "absolute",
      top: 5,
      right: -28,
      content: `''`,
      width: theme.spacing(3),
      height: theme.spacing(3),
      backgroundColor: theme.palette.primary.main,
      borderRadius: "50%",
    },
    "&:after": {
      position: "absolute",
      top: 35,
      right: -20,
      content: `''`,
      width: theme.spacing(1),
      height: theme.spacing(1),
      backgroundColor: theme.palette.primary.main,
      borderRadius: "50%",
    },
  },
  circle: {
    borderRadius: "50%",
    width: theme.spacing(18),
    height: theme.spacing(18),
    margin: "auto",
    backgroundColor: theme.palette.primary.main,
    position: "relative",
    overflow: "hidden",

    "& img": {
      borderRadius: "50%",
      position: "absolute",
      width: "inherit",
      height: "inherit",
    },
  },

  detailII: {
    maxWidth: 1200,
  },
  ListII: {
    position: "relative",
    margin: "auto",
    display: "flex",
    flexWrap: "wrap",
    flexGrow: "auto",
    justifyContent: "center",
    alignItems: "start",
    boxSizing: "border-box",
  },
  ListItemII: {
    width: theme.spacing(30),
    margin: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
    [theme.breakpoints.down("sm")]: {
      width: theme.spacing(24),
    },
  },
  ListItemTextII: {
    textAlign: "center",
  },
}))

export default function () {
  const [state] = React.useState({
    services: [
      {
        id: 299,
        title: "EVENT PLANNING",
        caption: "Let's plan you a special event",
        description:
          "Have a budget yet? know the best spots to get affordable quality items, bring your idea to life before the due date. These are part of what we offer",
        imgUrl: "event-planner.jpg",
      },
      {
        title: "EVENT DECORATION",
        caption: "Let's set the mood for the occasion",
        description:
          "Design is one of the things a guest remembers after attending a memorable occasion. Browse our gallery to experience some of our past designs.",
        imgUrl: "event-deco.jpg",
        id: 424,
      },
      {
        title: "HALL PROCUREMENT",
        caption: "We handle procurement at your request",
        description:
          "Gloone events can assist in procument of affordable event locations such as open field spaces, halls, beach houses...",
        imgUrl: "hall-procurement.jpg",
        id: 725,
      },
      {
        title: "GLOONE KITCHEN",
        caption: "Food order and delivery service for everyone",
        description:
          "We're run an event catering and food service. We deliver tasty native meals and snacks at your order across Lagos",
        imgUrl: "food.jpg",
        id: 526,
      },
      {
        title: "CORPORATE CATERING",
        caption: "We cater to corporate events across the country",
        description:
          "We offer a veriety of food and drinks, suitable for corporate functions. Browse our Menu list for more Information",
        imgUrl: "foreign_delicacies.jpg",
        id: 327,
      },
    ],
    eventlist: [
      {
        id: "130",
        title: "WEDDINGS (TRADITIONAL & WHITE)",
        imgUrl: "wedding.jpg",
      },
      {
        id: "140",
        title: "PRIVATE PARTIES",
        imgUrl: "private-party.jpg",
      },
      {
        id: "150",
        title: "BIRTHDAY PARTIES",
        imgUrl: "birthday-party.jpg",
      },
      {
        id: "160",
        title: "AWARD DINNERS",
        imgUrl: "award-dinner.jpg",
      },
      {
        id: "170",
        title: "THEMED EVENTS",

        imgUrl: "themed-event.jpg",
      },
      {
        id: "180",
        title: "PRODUCT LAUNCHES",
        imgUrl: "product-launch.jpg",
      },
      {
        id: "190",
        title: "COMPANY FUN DAYS",
        imgUrl: "company-fun-day.jpg",
      },
      {
        id: "200",
        title: "CORPORATE EVENTS",
        imgUrl: "corporate-event.jpg",
      },
    ],
  })
  const classes = useStyles()
  const listRef = React.useRef()
  let timer, direction
  const changeDir = dir => (direction = dir)
  const moveLeftInterval = () => {
    changeDir("left")
    startAnimationInterval()
  }
  const moveRightInterval = () => {
    changeDir("right")
    startAnimationInterval()
  }
  function animate() {
    if (direction === "right") {
      listRef.current.scrollLeft += 10
    } else if (direction === "left") {
      listRef.current.scrollLeft -= 10
    }
  }
  function startAnimationInterval() {
    timer = setInterval(animate, 30)
  }
  function stopAnimationInterval() {
    clearInterval(timer)
  }
  const { services, eventlist } = state
  return (
    <Box component="section" id="services" className={classes.Section}>
      <Box className={classes.Container}>
        <Box className={classes.headline}>
          <Typography variant="h2" className={classes.h2}>
            OUR SERVICES
          </Typography>
          <Typography className={classes.Description}>
            Things we love doing for You!
          </Typography>
        </Box>
        <Box className={classes.details}>
          <List ref={listRef} className={classes.List} id="cardList">
            {services.map(service => (
              <ListItem
                className={classes.ListItem}
                key={service.id.toString()}
              >
                <Box className={classes.imageBox}>
                  {service.imgUrl && (
                    <img
                      className={classes.img}
                      src={service.imgUrl}
                      alt={service.title}
                    />
                  )}
                </Box>
                <Box className={classes.ListItemText}>
                  <Typography variant="h3">{service.title}</Typography>
                  <Typography paragraph>{service.caption}</Typography>
                  <Typography paragraph>{service.description}</Typography>
                </Box>
              </ListItem>
            ))}
          </List>
          <ScrollButton
            cls="scroll-btn"
            id="scroll-btn-left"
            style={[classes.Btn, classes.BtnLeft]}
            direction="LEFT"
            move={moveLeftInterval}
            stopAnimationInterval={stopAnimationInterval}
          />
          <ScrollButton
            cls="scroll-btn"
            id="scroll-btn-right"
            style={[classes.Btn, classes.BtnRight]}
            direction="RIGHT"
            move={moveRightInterval}
            stopAnimationInterval={stopAnimationInterval}
          />
        </Box>
      </Box>
      <Box className={classes.Container}>
        <Box className={classes.headline} p={6}>
          <Typography className={classes.Description}>
            Events we've covered so far
          </Typography>
        </Box>
        <Box className={classes.detailsII}>
          <List className={classes.ListII}>
            {eventlist.map(event => (
              <ListItem key={event.id} className={classes.ListItemII}>
                <Box className={classes.imageCircle}>
                  <Box className={classes.circle}>
                    {event.imgUrl && (
                      <img src={event.imgUrl} alt={event.title} />
                    )}
                  </Box>
                </Box>
                <Typography className={classes.ListItemTextII}>
                  {event.title}
                </Typography>
              </ListItem>
            ))}
          </List>
        </Box>
      </Box>
    </Box>
  )
}
